export default "__VITE_ASSET__C0$t7UBH__"